import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { colors } from '../../constants';

const TooltipCard = styled.div``;
const TitleBar = styled.div``;
const Price = styled.span``;

interface IProps {
    className?: string;
    children: React.ReactNode;
    delay?: number;
    description?: string;
    price?: string;
    title: string;
}

const BaseTooltip = ({
    className,
    children,
    delay,
    title,
    description,
    price,
}: IProps) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    const handleMouseEnter = () => {
        if (!description) return;

        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    const getActiveHeight = () => {
        if (!ref.current) return;

        return `-${ref.current.scrollHeight + 10}px`;
    };

    return (
        <div
            className={className}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {children}
            <TooltipCard
                className={showTooltip ? 'show' : ''}
                ref={ref}
                style={{ top: getActiveHeight() }}
            >
                <TitleBar>
                    <h4>{title}</h4>
                    {price && <Price>{price}</Price>}
                </TitleBar>
                {description && <p>{description}</p>}
            </TooltipCard>
        </div>
    );
};

export const Tooltip = styled(BaseTooltip)`
    position: relative;
    display: block;

    ${TooltipCard} {
        background-color: ${colors.white};
        box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.15);
        position: absolute;
        visibility: hidden;
        line-height: 1.5;
        left: 0;
        opacity: 0;
        border-radius: 3px;
        padding: 15px;
        width: 300px;
        transition: opacity 0.15s ease-out;
        will-change: opacity, visibility;
    }

    ${TitleBar} {
        display: flex;
        justify-content: space-between;
    }

    ${TooltipCard}, h4,
    ${Price} {
        font-size: 13px;
    }

    h4,
    ${Price} {
        margin: 0;
        font-weight: 700;
    }

    .show {
        visibility: visible;
        opacity: 1;
    }
`;
